import React from 'react';

type Props = {
  score: number;
  showLabel?: boolean;
  height?: number;
};

export default function TrustScoreBar({ score, showLabel = true, height = 6 }: Props) {
  const color =
    score >= 90 ? 'bg-primary' : score >= 75 ? 'bg-accent' : score >= 60 ? 'bg-warning' : 'bg-destructive';

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="flex-1 bg-secondary rounded-full overflow-hidden" style={{ height }}>
        <div
          className={`${color} rounded-full transition-all duration-700`}
          style={{ width: `${score}%`, height: '100%' }}
          role="progressbar"
          aria-valuenow={score}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      {showLabel && (
        <span className="text-xs font-semibold text-muted-foreground font-tabular w-8 text-right">
          {score}
        </span>
      )}
    </div>
  );
}